class ApiEndpoints {
  static serverURL =
    // process.env.REACT_APP_SERVER_URL ||
    "https://server.ttrprogramming.com";
  // "http://192.168.1.24:5000";
  static assetURL =
    // process.env.REACT_APP_ASSET_URL ||
    "https://assets.ttrprogramming.com";

  static baseApiURL = `${this.serverURL}/api/v1`;
  static baseAssetUrl = `${this.assetURL}`;

  static getExerciseOption = `/system-option`;

  //for admin
  static admin = `/admin`;
  static adminLogin = `${this.admin}/login`;
  static forgetAdminPassword = `${this.admin}/forget-password`;
  static resetAdminPasswords = `${this.admin}/reset-password`;
  static resetAdminPassword = `${this.admin}/change-password`;
  static adminProfile = `${this.admin}/profile`;

  // for sessions
  static session = `/session`;
  static createSession = `${this.session}`;
  static getSessions = `${this.session}`;
  static sessionById = `${this.session}`;
  static editSession = `${this.session}`;
  static sessionDelete = `${this.session}`;
  static duplicateSession = `${this.session}/duplicate`;

  //for format

  static sessionFormat = `/session-format`;
  static createFormat = `${this.sessionFormat}`;
  static sessionFormatById = `${this.sessionFormat}/session/`;
  static formatBySessionId = `${this.sessionFormat}`;
  static formatSessionById = `${this.sessionFormat}`;
  static sessionFormatDelete = `${this.sessionFormat}`;
  static editSessionFormat = `${this.sessionFormat}`;
  static getScheduleDetails = `${this.sessionFormat}`;

  // for Gym
  static gym = `/gym`;
  static createGym = `${this.gym}`;
  static getGyms = `${this.gym}`;
  static gymById = `${this.gym}`;
  static editGym = `${this.gym}`;
  static gymDelete = `${this.gym}`;

  // for schedule
  static schedule = "/scheduled-session";
  static addGymSchedule = `${this.schedule}`;
  static deleteGymSchedule = `${this.schedule}`;
  static getScheduleGym = `${this.schedule}`;
  static duplicateSchedule = `${this.schedule}/duplicate`;

  //for Exercise
  static exercise = `/exercise`;
  static getExercisesByCategory = `/exercise`;
  static getExercises = `${this.exercise}`;
  static getExerciseCategory = `/exercise-category`;
  static getSessionFormatCategory = `/session-format-category`;
  static addSessionFormatCategory = `/session-format-category`;
  static deleteSessionFormatCategory = `/session-format-category`;
  static createExercise = `${this.exercise}`;
  static exerciseById = `${this.exercise}`;
  static editExercise = `${this.exercise}`;
  static deleteExercise = `${this.exercise}`;
  static exercisePrimaryVideoUpload = `${this.exercise}/upload-video`;
  static exerciseSecondaryVideoUpload = `${this.exercise}/upload-video`;
  static exerciseVideoDelete = `${this.exercise}/remove-video`;
}
export default ApiEndpoints;
